module.exports = __webpack_public_path__ + "img/new_logo_black.2832bd8f.png";